//Importar helper con la url para la petición.
import { Global } from "../../config/global";


//Importar dependencias de axios para la petición.
import axios from "axios";

//Función para enviar un mensaje.
export const sendMessage = async ({ idMessegeSession, identificador, mensaje, buffer, type,  }) => {

    let token = localStorage.getItem('token'); //Extraer el token del localStorage.
    let data = new FormData();
    let userData = JSON.parse(localStorage.getItem("userData"));
    let idUsuario = userData.IdUsuario;
    let url = Global.url + `messages/send/${idUsuario}` //Si no existe ningun valor de ultima posicion, se trata de una peticion de chats normales.

    data.append('file', buffer); //Añadir el file al FormData.
    data.append('IdMessegeSession', idMessegeSession);  //Añadir el id de la sesión al FormData.
    data.append('Identificador', identificador);  //Añadir el identificador al FormData.
    data.append('Type', type);  //Añadir el tipo del archivo al FormData.
    data.append('Text', mensaje);  //Añadir el texto del mensaje al FormData.
    console.log("este es el body del file", buffer, idMessegeSession, identificador, type, mensaje)
    let config = {
        method: 'post',
        url: url,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

//Función para enviar un archivo multimedia.
export const sendFile = async (filesSelected, mensaje, typeFile) => {
    try {
        // Mapear cada archivo en filesSelected y enviarlo individualmente
        await Promise.all(filesSelected.map(async file => {    

            const response = await sendMessage({
                idMessegeSession: 1,
                identificador: "595971521771",
                mensaje: mensaje,
                buffer: file,
                type: typeFile,
            });
        }));

    } catch (error) {
        console.error("Error al enviar archivos:", error);
    }
};


